<template>
  <div class="mainbox" style="background: #f4f4f4">
    <div
      data-aos="fade-left"
      data-aos-delay="200"
      data-aos-easing="ease-in-out"
      data-aos-anchor-placement="top-bottom"
      data-aos-offset="120"
    >
      <h2 class="tit">{{ lang[local].part5_txt1 }}</h2>

      <div class="sb">
        <div>
          <dl>
            <dt @click="toUrl(urlMap.userManual.en)">{{ lang[local].part5_txt2 }}</dt>
            <dd>
              <div @click="toUrl(urlMap.userManual.en)" id="qrcode1" ref="qrcode1"></div>
            </dd>
          </dl>
          <dl>
            <dt @click="toUrl(urlMap.userManual.cn)">{{ lang[local].part5_txt3 }}</dt>
            <dd>
              <div @click="toUrl(urlMap.userManual.cn)" id="qrcode2" ref="qrcode2"></div>
            </dd>
          </dl>
        </div>
        <div>
          <dl>
            <dt @click="toUrl(urlMap.userManualVideo.en)">{{ lang[local].part5_txt4 }}</dt>
            <dd>
              <div @click="toUrl(urlMap.userManualVideo.en)" id="qrcode3" ref="qrcode3"></div>
            </dd>
          </dl>
          <dl>
            <dt @click="toUrl(urlMap.aboutUs[local])">{{ lang[local].part5_txt5 }}</dt>
            <dd>
              <div @click="toUrl(urlMap.aboutUs[local])" id="qrcode4" ref="qrcode4"></div>
            </dd>
          </dl>
        </div>
        <div class="logo">
                <b>Blockchain</b>
                <span>Venture Capital</span>
            </div>
      </div>
        
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      urlMap: {
        userManual: {
          cn: "https://www.bvcadt.com/docs/user_manual_cn.pdf",
          en: "https://www.bvcadt.com/docs/user_manual_en.pdf"
        },
        userManualVideo: {
          cn: "",
          en: "https://www.bvcadt.com/docs/user_manual_video.m4v"
        },
        aboutUs: {
          cn: "https://www.bvcadt.com/docs/about_us_cn.mp4",
          en: "https://www.bvcadt.com/docs/about_us_en.mp4",
          hk: "https://www.bvcadt.com/docs/about_us_cn.mp4"
        }
      }
    };
  },

  components: { QRCode },
  computed: mapState(["lang", "local", "skin"]),
  watch: {
    local(va) {
      this.getCode();
    }
  },
  mounted() {
    this.getCode();
  },
  methods: {
    //  初始化二维码
    getCode() {
      this.qrcode("qrcode1", this.urlMap.userManual.en);
      this.qrcode("qrcode2", this.urlMap.userManual.cn);
      this.qrcode("qrcode3", this.urlMap.userManualVideo.en);
      this.qrcode("qrcode4", this.urlMap.aboutUs[this.local]);
    },

    /**
     * @description 生成二维码
     * @param {string}  idRef  渲染节点id 和 ref
     * @param  {number} qWidth  宽度
     * @param  {number} qHeight  高度
     * @param  {string} qText  二维码内容（跳转连接）
     * @param  {string} qRender 渲染方式（有两种方式 table和canvas，默认是canvas）
     */
    qrcode(idRef, qText, qWidth = 100, qHeight = 100, qRender = "canvas") {
      this.$refs[idRef].innerHTML = "";
      eval(
        new QRCode(idRef, {
          width: qWidth,
          height: qHeight,
          text: qText,
          render: qRender
        })
      );
    },
    toUrl(url){
        window.open(url,"_blank")
    }
  }
};
</script>

<style lang="less" scoped>
.sb {
  padding: 20px;
  overflow: hidden;
  font-size: 14px;
  div {
    overflow: hidden;
  }
  dl {
    width: 30%;
    margin: 0 10%;
    margin-top: 30px;
    float: left;
    dt {
      color: #e95b57;
      font-size: 18px;
      cursor: pointer;
      i {
        font-size: 40px;
        position: relative;
        top: 7px;
      }
    }
    dd {
      padding: 40px 0;
      cursor: pointer;
      img {
        width: 200px;
        height: 200px;
      }
    }
  }
   .logo{
            float: right;
            background: url("../../assets/images/logo.png") no-repeat;
            padding-left:70px;
            width:185px;
            height:60px;
            b{display:block;font-size:20px;color:#912121;margin-top:13px;line-height: 18px;}
            span{color: #431717;font-size:14px;line-height: 16px;}
        }
}

</style>

